import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "tw-w-full tw-h-full" }
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4"
}
const _hoisted_3 = { class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-6 tw-w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "tw-w-[540px] tw-max-h-[570px] tw-border-b-solid-custom tw-flex tw-flex-col tw-gap-4 tw-overflow-x-hidden tw-overflow-y-auto tw-pb-4 tw-max-w-full"
}
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-gap-3" }
const _hoisted_7 = {
  key: 0,
  class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-3"
}
const _hoisted_8 = { class: "tw-w-full tw-flex tw-items-center tw-justify-between" }
const _hoisted_9 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_10 = {
  key: 1,
  class: "!tw-rounded-lg tw-overflow-hidden tw-max-h-[32px] tw-max-w-[32px] tw-min-h-[32px] tw-min-w-[32px] tw-h-[32px] tw-relative"
}
const _hoisted_11 = { class: "tw-text-xs tw-text-[#0C0F4A] tw-leading-4 tw-font-semi-bold" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "tw-w-full" }
const _hoisted_14 = {
  key: 0,
  class: "tw-w-full tw-grid tw-grid-cols-2 tw-items-center tw-gap-3"
}
const _hoisted_15 = {
  key: 1,
  class: "tw-w-full tw-grid tw-grid-cols-2 tw-items-center tw-gap-3"
}

import { computed, ref, reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Text from "@/core/components/ui/general/Text.vue";
import Button from "@/core/components/ui/general/Button.vue";
import InputField from "@/core/components/common/InputField.vue";
import InputSelect from "@/core/components/common/InputSelect.vue";
import UploadForm from "@/core/components/forms/Upload.vue";
import ProfileThumbnail from "@/core/uni-components/ProfileThumbnail.vue";
import UserProfileLogo from "@/core/components/UserProfileLogo.vue";
import TrashIcon from "@/core/components/icons/TrashIcon.vue";

import { PROPERTY_STORE } from "@/store/modules/property";
import { CONNECTIONS } from "@/store/modules/connections";
import { USER_STORE } from "@/store/modules/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageConnectionsModal',
  emits: ["on-close", "on-success"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const store = useStore();
const route = useRoute();

const filters = reactive({
  keywords: "",
});

const selectedConnection = ref(null) as any;
const isDeleting = ref(false);
const loading = ref(false);
const showRemoveConfirmation = ref(false);
const inviteAsType = ref(["admin", "editor", "viewer"]);

const propertyId = computed(() => route?.params?.propertyId);
const user = computed(() => store.getters[`${USER_STORE}/user`]);

const propertyConnections = computed(
  () => store.getters[`${CONNECTIONS}/propertyConnections`]
);

const onConfirmRemoveConnection = (connection: any) => {
  selectedConnection.value = connection;
  showRemoveConfirmation.value = true;
};

const onCancelRemove = () => {
  selectedConnection.value = null;
  showRemoveConfirmation.value = false;
};
const initialize = async () => {
  const payload = {
    userId: user.value?.id,
    propertyId: propertyId.value,
  };
  loading.value = true;
  try {
    await store.dispatch(`${CONNECTIONS}/getConnectionsOfProperty`, payload);
  } catch (error) {
    loading.value = false;
  } finally {
    loading.value = false;
  }
};

const onRemoveConnection = async () => {
  try {
    isDeleting.value = true;
    // console.log(selectedConnection.value, "selectedConnection");
    await store.dispatch(`${CONNECTIONS}/rejectPropertyUserConnection`, {
      userId: user.value?.id,
      tradeUserConnectionId: selectedConnection.value.id,
    });
    await initialize();
  } catch (error) {
    console.log("error", error);
  } finally {
    isDeleting.value = false;
    showRemoveConfirmation.value = false;
  }
};

const onCloseModal = () => {
  emits("on-close");
};
const onDone = () => {
  onCloseModal();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeneralDialog, {
    onOnClose: onCloseModal,
    headerTitle: "Add New Report",
    isShowHeader: !showRemoveConfirmation.value,
    isShowCloseButton: !showRemoveConfirmation.value
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (showRemoveConfirmation.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(TrashIcon, {
                  fillOpacity: "1",
                  fill: "#F45454",
                  class: "tw-w-[27px] tw-h-[35px]"
                }),
                _createVNode(Text, {
                  variant: "h4",
                  textAlign: "center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Remove Connection")
                  ]),
                  _: 1
                }),
                _createVNode(Text, {
                  variant: "p",
                  textWeight: "400",
                  textAlign: "center",
                  textColor: "rgba(12, 15, 74, 0.5)",
                  lineHeight: "18px"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Are you sure you want to"),
                    _hoisted_4,
                    _createTextVNode(" Remove Connection?")
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(InputField, {
                  "prepend-inner-icon": "mdi-magnify",
                  placeholder: "Search",
                  modelValue: filters.keywords,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.keywords) = $event))
                }, null, 8, ["modelValue"])
              ]),
              (propertyConnections.value && propertyConnections.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propertyConnections.value, (connection, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "tw-bg-[rgba(241,246,251,0.86)] tw-w-full tw-rounded-md tw-flex tw-flex-col tw-justify-between tw-gap-3 tw-p-4 tw-box-border"
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            (connection?.userWorkstation?.profileImageUrl)
                              ? (_openBlock(), _createBlock(ProfileThumbnail, {
                                  key: 0,
                                  size: "mmd",
                                  class: "!tw-rounded-full !tw-overflow-hidden",
                                  src: connection?.userWorkstation?.profileImageUrl
                                }, null, 8, ["src"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createVNode(UserProfileLogo, {
                                    class: "ws-profile-logo",
                                    userName: connection?.userWorkstation?.name
                                  }, null, 8, ["userName"])
                                ])),
                            _createElementVNode("h6", _hoisted_11, _toDisplayString(connection?.userWorkstation?.name), 1)
                          ]),
                          _createElementVNode("div", {
                            onClick: ($event: any) => (onConfirmRemoveConnection(connection)),
                            class: "tw-cursor-pointer tw-rounded-[5px] tw-border-solid tw-border-[.83px] tw-border-[#FF3636] tw-min-w-[140px] tw-max-w-[140px] tw-min-h-[20px] tw-flex tw-items-center tw-justify-center tw-gap-1"
                          }, [
                            _createVNode(Text, {
                              variant: "xsmall",
                              textColor: "#FF3636",
                              whiteSpace: "nowrap"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("REMOVE CONNECTION")
                              ]),
                              _: 1
                            })
                          ], 8, _hoisted_12)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_13, [
        (showRemoveConfirmation.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(Button, {
                variant: "secondary",
                disabled: isDeleting.value,
                label: "Cancel",
                isActive: true,
                onClick: onCancelRemove
              }, null, 8, ["disabled"]),
              _createVNode(Button, {
                disabled: isDeleting.value,
                isLoading: isDeleting.value,
                variant: "accent",
                label: "Remove",
                isActive: true,
                onClick: onRemoveConnection
              }, null, 8, ["disabled", "isLoading"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(Button, {
                variant: "secondary",
                label: "close",
                isActive: true,
                onClick: onCloseModal
              }),
              _createVNode(Button, {
                variant: "accent",
                label: "done",
                isActive: true,
                onClick: onDone
              })
            ]))
      ])
    ]),
    _: 1
  }, 8, ["isShowHeader", "isShowCloseButton"]))
}
}

})